import React from 'react';
import PropTypes from 'prop-types';
import RadioGroup from '../../../components/RadioGroup/RadioGroup';
import './FeedbackForm.css';

class FeedbackForm extends React.PureComponent {
    constructor(props) {
        super(props);
        window.scrollTo(0, 0);
    }

    onSubmit = event => {
        event.preventDefault();
        if (this.isValidForm()) {
            this.props.submitFFForm();
        }
    };

    closeAlert = () => {
        this.props.updateFormStatus('formFailed', false);
    };

    isValidForm = () => {
        if (
            (this.props.fields.email.value !== '' && this.props.fields.userName.value === '') ||
            (this.props.fields.email.value === '' && this.props.fields.userName.value !== '')
        ) {
            return false;
        }

        if (
            this.props.fields.userName.value !== '' &&
            !/(.+)@(.+){2,}\.(.+){2,}/.test(this.props.fields.email.value)
        ) {
            return false;
        }

        // eslint-disable-next-line
        return Object.keys(this.props.fields).every(key =>
            this.props.fields[key].required ? this.props.fields[key].value : true
        );
    };

    render() {
        const data = this.props.fields;
        const submitFailedMessage = this.props.formFailed ? (
            <div className="notification is-danger alert-submit-failed text-center" role="alert">
                <button
                    aria-label="Close"
                    className="delete"
                    data-dismiss="alert"
                    onClick={this.closeAlert}
                    type="button"
                >
                    <span aria-hidden="true">×</span>
                </button>
                {this.props.message !== ''
                    ? this.props.message
                    : 'Something went wrong and your information was not stored. Please, try again.'}
            </div>
        ) : null;

        const submitSuccessMessage = this.props.formSubmitted ? (
            <div className="notification is-success text-center" role="alert">
                Feedback was successfully submitted, thank you.
            </div>
        ) : null;

        const inProgress = this.props.formSubmitInProgress ? (
            <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
        ) : null;

        const missingFieldsMessage = this.isValidForm() ? null : (
            <h3 className="text-center ff-bottom-request">
                <b className="text-danger ff-request">Please fill in all required fields (*).</b>
            </h3>
        );

        return (
            <section className="section" id="ff">
                <div className="page-header text-center ff-form">
                    <h1 className="title">Feedback Form</h1>
                </div>
                {missingFieldsMessage}
                <div className="container feedback-form">
                    <form className="form-horizontal" noValidate onSubmit={this.onSubmit}>
                        <div className="form-group field is-horizontal columns">
                            <label
                                className="control column is-4 label"
                                htmlFor="overall-assessment"
                            >
                                Overall assessment of the conference{' '}
                                <strong className="red-font">*</strong>
                            </label>
                            <div className="control field column" name="overall-assessment">
                                <RadioGroup
                                    dataField={data.overall.value}
                                    name="overall"
                                    updateValue={this.props.updateValue}
                                />
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label
                                className="control column is-4 label"
                                htmlFor="overall-assessment-comment"
                            >
                                Additional comment about overall assessment
                            </label>
                            <div className="column fix-space-sm" name="overall-assessment-comment">
                                <textarea
                                    className="form-control textarea"
                                    maxLength="1000"
                                    name="overallComment"
                                    onChange={this.props.updateValue}
                                    placeholder="Your additional assessment. Maximum 1000 characters."
                                    type="text"
                                    value={data.overallComment.value}
                                />
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label className="control column is-4 label" htmlFor="learnAbout">
                                How did you learn about the conference?{' '}
                                <strong className="red-font">*</strong>
                            </label>
                            <div className="column">
                                <div className="select custom-select-sm level-right is-rounded">
                                    <select
                                        className="custom-select"
                                        name="learnAbout"
                                        onChange={this.props.updateValue}
                                        value={data.learnAbout.value}
                                    >
                                        <option key="0" value="" />
                                        <option key="1" value="robime.it">
                                            robime.it
                                        </option>
                                        <option
                                            key="2"
                                            value="Social media (facebook, twitter, ...)"
                                        >
                                            Social media (facebook, twitter, ...)
                                        </option>
                                        <option key="3" value="Email invitation">
                                            Email invitation
                                        </option>
                                        <option key="4" value="Leaflet/poster">
                                            Leaflet/poster
                                        </option>
                                        <option key="5" value="Recommended by friend/colleague">
                                            Recommended by friend/colleague
                                        </option>
                                        <option
                                            key="6"
                                            value="Attended previous editions of OpenSlava"
                                        >
                                            Attended previous editions of OpenSlava
                                        </option>
                                        <option
                                            key="7"
                                            value="Accenture internal channels (employee)"
                                        >
                                            Accenture internal channels (employee)
                                        </option>
                                        <option key="8" value="Other">
                                            Other
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label className="control column is-4 label" htmlFor="overall-program">
                                Overall assessment of the conference program (presentations and
                                speakers) <strong className="red-font">*</strong>
                            </label>
                            <div className="control field column" name="overall-program">
                                <RadioGroup
                                    dataField={data.program.value}
                                    name="program"
                                    updateValue={this.props.updateValue}
                                />
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label
                                className="control column is-4 label"
                                htmlFor="overall-program-best"
                            >
                                The best talk (pls. include reason in comment)
                            </label>
                            <div className="column fix-space-sm" name="overall-program-best">
                                <textarea
                                    className="form-control textarea"
                                    maxLength="1000"
                                    name="programBestSpeaker"
                                    onChange={this.props.updateValue}
                                    placeholder="Talk that was the best. Maximum 1000 characters."
                                    type="text"
                                    value={data.programBestSpeaker.value}
                                />
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label
                                className="control column is-4 label"
                                htmlFor="overall-program-worst"
                            >
                                The worst talk (pls. include reason in comment)
                            </label>
                            <div className="column fix-space-sm" name="overall-program-worst">
                                <textarea
                                    className="form-control textarea"
                                    maxLength="1000"
                                    name="programWorstSpeaker"
                                    onChange={this.props.updateValue}
                                    placeholder="Talk that was the worst. Maximum 1000 characters."
                                    type="text"
                                    value={data.programWorstSpeaker.value}
                                />
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label className="control column is-4 label" htmlFor="location">
                                How would you assess the location of the conference{' '}
                                <strong className="red-font">*</strong>
                            </label>
                            <div className="control field column" name="location">
                                <RadioGroup
                                    dataField={data.location.value}
                                    name="location"
                                    updateValue={this.props.updateValue}
                                />
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label className="control column is-4 label" htmlFor="location-comment">
                                Additional comment about location
                            </label>
                            <div className="column fix-space-sm" name="location-comment">
                                <textarea
                                    className="form-control textarea"
                                    maxLength="1000"
                                    name="locationComment"
                                    onChange={this.props.updateValue}
                                    placeholder="Your opinion about location. Maximum 1000 characters."
                                    type="text"
                                    value={data.locationComment.value}
                                />
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label className="control column is-4 label" htmlFor="perception">
                                How did OpenSlava 2019 influence your perception of Accenture as one
                                of the leading technology companies?{' '}
                                <strong className="red-font">*</strong>
                            </label>
                            <div className="control field column" name="perception">
                                <div className="field is-left is-horizontal">
                                    <label className="radio">
                                        <input
                                            checked={data.perception.value === 'In a positive way'}
                                            name="perception"
                                            onChange={this.props.updateValue}
                                            type="radio"
                                            value="In a positive way"
                                        />{' '}
                                        In a positive way
                                    </label>
                                </div>
                                <div className="field is-left is-horizontal">
                                    <label className="radio">
                                        <input
                                            checked={
                                                data.perception.value ===
                                                'Did not change my perception'
                                            }
                                            name="perception"
                                            onChange={this.props.updateValue}
                                            type="radio"
                                            value="Did not change my perception"
                                        />{' '}
                                        Did not change my perception
                                    </label>
                                </div>
                                <div className="field is-left is-horizontal">
                                    <label className="radio">
                                        <input
                                            checked={data.perception.value === 'In a negative way'}
                                            name="perception"
                                            onChange={this.props.updateValue}
                                            type="radio"
                                            value="In a negative way"
                                        />{' '}
                                        In a negative way
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label className="control column is-4 label" htmlFor="other">
                                Other comments
                            </label>
                            <div className="column fix-space-sm" name="other">
                                <textarea
                                    className="form-control textarea"
                                    maxLength="1000"
                                    name="otherComments"
                                    onChange={this.props.updateValue}
                                    placeholder="Any other ideas. Maximum 1000 characters."
                                    type="text"
                                    value={data.otherComments.value}
                                />
                            </div>
                        </div>

                        <hr />

                        <div className="form-group columns">
                            <label className="control column is-4 label" htmlFor="email">
                                Submit your feedback anonymously or provide us with your contact
                                details and have a chance to win iPad mini 256GB 2019, Samsung
                                Galaxy Watch, or Apple AirPods 2019 from Accenture in our lottery{' '}
                                <ins>(both fields are required in such case)</ins>
                            </label>
                            <div className="column fix-space-sm">
                                <input
                                    className="control input is-rounded"
                                    name="email"
                                    onChange={this.props.updateValue}
                                    placeholder="Your email"
                                    type="email"
                                    value={data.email.value}
                                />
                            </div>
                            <div className="column fix-space-sm">
                                <input
                                    className="control input is-rounded"
                                    name="userName"
                                    onChange={this.props.updateValue}
                                    placeholder="Your name"
                                    type="text"
                                    value={data.userName.value}
                                />
                            </div>
                        </div>

                        {missingFieldsMessage}
                        {submitSuccessMessage}
                        {submitFailedMessage}
                        {inProgress}

                        <div className="submit">
                            <button
                                className="button is-large is-rounded btn-submit"
                                disabled={
                                    !this.isValidForm() ||
                                    this.props.formSubmitInProgress ||
                                    this.props.formSubmitted
                                }
                                type="submit"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </section>
        );
    }
}

FeedbackForm.propTypes = {
    // eslint-disable-next-line
    fields: PropTypes.object.isRequired,
    formFailed: PropTypes.bool.isRequired,
    formSubmitInProgress: PropTypes.bool.isRequired,
    formSubmitted: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    submitFFForm: PropTypes.func.isRequired,
    updateFormStatus: PropTypes.func.isRequired,
    updateValue: PropTypes.func.isRequired
};

export default FeedbackForm;
